/**
 * Theme JS — The Monroe Institute
 *
 * Single consolidated script loaded on every page.
 * Contains: Siema slider library, header/navigation, sliders,
 * quiz modal, donation popup, trainer filter, and product gallery.
 */

/* ==========================================================================
   Vendor: Siema Slider (v1.5.1)
   ========================================================================== */
!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
      ? define('Siema', [], t)
      : 'object' == typeof exports
        ? (exports.Siema = t())
        : (e.Siema = t())
})('undefined' != typeof self ? self : this, function () {
  return (function (e) {
    function t(r) {
      if (i[r]) return i[r].exports
      var n = (i[r] = {
        i: r,
        l: !1,
        exports: {},
      })
      return (e[r].call(n.exports, n, n.exports, t), (n.l = !0), n.exports)
    }
    var i = {}
    return (
      (t.m = e),
      (t.c = i),
      (t.d = function (e, i, r) {
        t.o(e, i) ||
          Object.defineProperty(e, i, {
            configurable: !1,
            enumerable: !0,
            get: r,
          })
      }),
      (t.n = function (e) {
        var i =
          e && e.__esModule
            ? function () {
                return e.default
              }
            : function () {
                return e
              }
        return (t.d(i, 'a', i), i)
      }),
      (t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
      }),
      (t.p = ''),
      t((t.s = 0))
    )
  })([
    function (e, t, i) {
      'use strict'

      function r(e, t) {
        if (!(e instanceof t)) throw new TypeError('Cannot call a class as a function')
      }
      Object.defineProperty(t, '__esModule', {
        value: !0,
      })
      var n =
          'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator
            ? function (e) {
                return typeof e
              }
            : function (e) {
                return e && 'function' == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype
                  ? 'symbol'
                  : typeof e
              },
        s = (function () {
          function e(e, t) {
            for (var i = 0; i < t.length; i++) {
              var r = t[i]
              ;((r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r))
            }
          }
          return function (t, i, r) {
            return (i && e(t.prototype, i), r && e(t, r), t)
          }
        })(),
        l = (function () {
          function e(t) {
            var i = this
            if (
              (r(this, e),
              (this.config = e.mergeSettings(t)),
              (this.selector =
                'string' == typeof this.config.selector
                  ? document.querySelector(this.config.selector)
                  : this.config.selector),
              null === this.selector)
            )
              throw new Error('Something wrong with your selector 😭')
            ;(this.resolveSlidesNumber(),
              (this.selectorWidth = this.selector.offsetWidth),
              (this.innerElements = [].slice.call(this.selector.children)),
              (this.currentSlide = this.config.loop
                ? this.config.startIndex % this.innerElements.length
                : Math.max(0, Math.min(this.config.startIndex, this.innerElements.length - this.perPage))),
              (this.transformProperty = e.webkitOrNot()),
              [
                'resizeHandler',
                'touchstartHandler',
                'touchendHandler',
                'touchmoveHandler',
                'mousedownHandler',
                'mouseupHandler',
                'mouseleaveHandler',
                'mousemoveHandler',
                'clickHandler',
              ].forEach(function (e) {
                i[e] = i[e].bind(i)
              }),
              this.init())
          }
          return (
            s(
              e,
              [
                {
                  key: 'attachEvents',
                  value: function () {
                    ;(window.addEventListener('resize', this.resizeHandler),
                      this.config.draggable &&
                        ((this.pointerDown = !1),
                        (this.drag = {
                          startX: 0,
                          endX: 0,
                          startY: 0,
                          letItGo: null,
                          preventClick: !1,
                        }),
                        this.selector.addEventListener('touchstart', this.touchstartHandler),
                        this.selector.addEventListener('touchend', this.touchendHandler),
                        this.selector.addEventListener('touchmove', this.touchmoveHandler),
                        this.selector.addEventListener('mousedown', this.mousedownHandler),
                        this.selector.addEventListener('mouseup', this.mouseupHandler),
                        this.selector.addEventListener('mouseleave', this.mouseleaveHandler),
                        this.selector.addEventListener('mousemove', this.mousemoveHandler),
                        this.selector.addEventListener('click', this.clickHandler)))
                  },
                },
                {
                  key: 'detachEvents',
                  value: function () {
                    ;(window.removeEventListener('resize', this.resizeHandler),
                      this.selector.removeEventListener('touchstart', this.touchstartHandler),
                      this.selector.removeEventListener('touchend', this.touchendHandler),
                      this.selector.removeEventListener('touchmove', this.touchmoveHandler),
                      this.selector.removeEventListener('mousedown', this.mousedownHandler),
                      this.selector.removeEventListener('mouseup', this.mouseupHandler),
                      this.selector.removeEventListener('mouseleave', this.mouseleaveHandler),
                      this.selector.removeEventListener('mousemove', this.mousemoveHandler),
                      this.selector.removeEventListener('click', this.clickHandler))
                  },
                },
                {
                  key: 'init',
                  value: function () {
                    ;(this.attachEvents(),
                      (this.selector.style.overflow = 'hidden'),
                      (this.selector.style.direction = this.config.rtl ? 'rtl' : 'ltr'),
                      this.buildSliderFrame(),
                      this.config.onInit.call(this))
                  },
                },
                {
                  key: 'buildSliderFrame',
                  value: function () {
                    var e = this.selectorWidth / this.perPage,
                      t = this.config.loop ? this.innerElements.length + 2 * this.perPage : this.innerElements.length
                    ;((this.sliderFrame = document.createElement('div')),
                      (this.sliderFrame.style.width = e * t + 'px'),
                      this.enableTransition(),
                      this.config.draggable && (this.selector.style.cursor = '-webkit-grab'))
                    var i = document.createDocumentFragment()
                    if (this.config.loop)
                      for (var r = this.innerElements.length - this.perPage; r < this.innerElements.length; r++) {
                        var n = this.buildSliderFrameItem(this.innerElements[r].cloneNode(!0))
                        i.appendChild(n)
                      }
                    for (var s = 0; s < this.innerElements.length; s++) {
                      var l = this.buildSliderFrameItem(this.innerElements[s])
                      i.appendChild(l)
                    }
                    if (this.config.loop)
                      for (var o = 0; o < this.perPage; o++) {
                        var a = this.buildSliderFrameItem(this.innerElements[o].cloneNode(!0))
                        i.appendChild(a)
                      }
                    ;(this.sliderFrame.appendChild(i),
                      (this.selector.innerHTML = ''),
                      this.selector.appendChild(this.sliderFrame),
                      this.slideToCurrent())
                  },
                },
                {
                  key: 'buildSliderFrameItem',
                  value: function (e) {
                    var t = document.createElement('div')
                    return (
                      (t.style.cssFloat = this.config.rtl ? 'right' : 'left'),
                      (t.style.float = this.config.rtl ? 'right' : 'left'),
                      (t.style.width =
                        (this.config.loop
                          ? 100 / (this.innerElements.length + 2 * this.perPage)
                          : 100 / this.innerElements.length) + '%'),
                      t.appendChild(e),
                      t
                    )
                  },
                },
                {
                  key: 'resolveSlidesNumber',
                  value: function () {
                    if ('number' == typeof this.config.perPage) this.perPage = this.config.perPage
                    else if ('object' === n(this.config.perPage)) {
                      this.perPage = 1
                      for (var e in this.config.perPage)
                        window.innerWidth >= e && (this.perPage = this.config.perPage[e])
                    }
                  },
                },
                {
                  key: 'prev',
                  value: function () {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                      t = arguments[1]
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide
                      if (this.config.loop) {
                        if (this.currentSlide - e < 0) {
                          this.disableTransition()
                          var r = this.currentSlide + this.innerElements.length,
                            n = this.perPage,
                            s = r + n,
                            l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                            o = this.config.draggable ? this.drag.endX - this.drag.startX : 0
                          ;((this.sliderFrame.style[this.transformProperty] = 'translate3d(' + (l + o) + 'px, 0, 0)'),
                            (this.currentSlide = r - e))
                        } else this.currentSlide = this.currentSlide - e
                      } else this.currentSlide = Math.max(this.currentSlide - e, 0)
                      i !== this.currentSlide &&
                        (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this))
                    }
                  },
                },
                {
                  key: 'next',
                  value: function () {
                    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                      t = arguments[1]
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide
                      if (this.config.loop) {
                        if (this.currentSlide + e > this.innerElements.length - this.perPage) {
                          this.disableTransition()
                          var r = this.currentSlide - this.innerElements.length,
                            n = this.perPage,
                            s = r + n,
                            l = (this.config.rtl ? 1 : -1) * s * (this.selectorWidth / this.perPage),
                            o = this.config.draggable ? this.drag.endX - this.drag.startX : 0
                          ;((this.sliderFrame.style[this.transformProperty] = 'translate3d(' + (l + o) + 'px, 0, 0)'),
                            (this.currentSlide = r + e))
                        } else this.currentSlide = this.currentSlide + e
                      } else
                        this.currentSlide = Math.min(this.currentSlide + e, this.innerElements.length - this.perPage)
                      i !== this.currentSlide &&
                        (this.slideToCurrent(this.config.loop), this.config.onChange.call(this), t && t.call(this))
                    }
                  },
                },
                {
                  key: 'disableTransition',
                  value: function () {
                    ;((this.sliderFrame.style.webkitTransition = 'all 0ms ' + this.config.easing),
                      (this.sliderFrame.style.transition = 'all 0ms ' + this.config.easing))
                  },
                },
                {
                  key: 'enableTransition',
                  value: function () {
                    ;((this.sliderFrame.style.webkitTransition =
                      'all ' + this.config.duration + 'ms ' + this.config.easing),
                      (this.sliderFrame.style.transition = 'all ' + this.config.duration + 'ms ' + this.config.easing))
                  },
                },
                {
                  key: 'goTo',
                  value: function (e, t) {
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide
                      ;((this.currentSlide = this.config.loop
                        ? e % this.innerElements.length
                        : Math.min(Math.max(e, 0), this.innerElements.length - this.perPage)),
                        i !== this.currentSlide &&
                          (this.slideToCurrent(), this.config.onChange.call(this), t && t.call(this)))
                    }
                  },
                },
                {
                  key: 'slideToCurrent',
                  value: function (e) {
                    var t = this,
                      i = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                      r = (this.config.rtl ? 1 : -1) * i * (this.selectorWidth / this.perPage)
                    e
                      ? requestAnimationFrame(function () {
                          requestAnimationFrame(function () {
                            ;(t.enableTransition(),
                              (t.sliderFrame.style[t.transformProperty] = 'translate3d(' + r + 'px, 0, 0)'))
                          })
                        })
                      : (this.sliderFrame.style[this.transformProperty] = 'translate3d(' + r + 'px, 0, 0)')
                  },
                },
                {
                  key: 'updateAfterDrag',
                  value: function () {
                    var e = (this.config.rtl ? -1 : 1) * (this.drag.endX - this.drag.startX),
                      t = Math.abs(e),
                      i = this.config.multipleDrag ? Math.ceil(t / (this.selectorWidth / this.perPage)) : 1,
                      r = e > 0 && this.currentSlide - i < 0,
                      n = e < 0 && this.currentSlide + i > this.innerElements.length - this.perPage
                    ;(e > 0 && t > this.config.threshold && this.innerElements.length > this.perPage
                      ? this.prev(i)
                      : e < 0 && t > this.config.threshold && this.innerElements.length > this.perPage && this.next(i),
                      this.slideToCurrent(r || n))
                  },
                },
                {
                  key: 'resizeHandler',
                  value: function () {
                    ;(this.resolveSlidesNumber(),
                      this.currentSlide + this.perPage > this.innerElements.length &&
                        (this.currentSlide =
                          this.innerElements.length <= this.perPage ? 0 : this.innerElements.length - this.perPage),
                      (this.selectorWidth = this.selector.offsetWidth),
                      this.buildSliderFrame())
                  },
                },
                {
                  key: 'clearDrag',
                  value: function () {
                    this.drag = {
                      startX: 0,
                      endX: 0,
                      startY: 0,
                      letItGo: null,
                      preventClick: this.drag.preventClick,
                    }
                  },
                },
                {
                  key: 'touchstartHandler',
                  value: function (e) {
                    ;-1 !== ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) ||
                      (e.stopPropagation(),
                      (this.pointerDown = !0),
                      (this.drag.startX = e.touches[0].pageX),
                      (this.drag.startY = e.touches[0].pageY))
                  },
                },
                {
                  key: 'touchendHandler',
                  value: function (e) {
                    ;(e.stopPropagation(),
                      (this.pointerDown = !1),
                      this.enableTransition(),
                      this.drag.endX && this.updateAfterDrag(),
                      this.clearDrag())
                  },
                },
                {
                  key: 'touchmoveHandler',
                  value: function (e) {
                    if (
                      (e.stopPropagation(),
                      null === this.drag.letItGo &&
                        (this.drag.letItGo =
                          Math.abs(this.drag.startY - e.touches[0].pageY) <
                          Math.abs(this.drag.startX - e.touches[0].pageX)),
                      this.pointerDown && this.drag.letItGo)
                    ) {
                      ;(e.preventDefault(),
                        (this.drag.endX = e.touches[0].pageX),
                        (this.sliderFrame.style.webkitTransition = 'all 0ms ' + this.config.easing),
                        (this.sliderFrame.style.transition = 'all 0ms ' + this.config.easing))
                      var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                        i = t * (this.selectorWidth / this.perPage),
                        r = this.drag.endX - this.drag.startX,
                        n = this.config.rtl ? i + r : i - r
                      this.sliderFrame.style[this.transformProperty] =
                        'translate3d(' + (this.config.rtl ? 1 : -1) * n + 'px, 0, 0)'
                    }
                  },
                },
                {
                  key: 'mousedownHandler',
                  value: function (e) {
                    ;-1 !== ['TEXTAREA', 'OPTION', 'INPUT', 'SELECT'].indexOf(e.target.nodeName) ||
                      (e.preventDefault(), e.stopPropagation(), (this.pointerDown = !0), (this.drag.startX = e.pageX))
                  },
                },
                {
                  key: 'mouseupHandler',
                  value: function (e) {
                    ;(e.stopPropagation(),
                      (this.pointerDown = !1),
                      (this.selector.style.cursor = '-webkit-grab'),
                      this.enableTransition(),
                      this.drag.endX && this.updateAfterDrag(),
                      this.clearDrag())
                  },
                },
                {
                  key: 'mousemoveHandler',
                  value: function (e) {
                    if ((e.preventDefault(), this.pointerDown)) {
                      ;('A' === e.target.nodeName && (this.drag.preventClick = !0),
                        (this.drag.endX = e.pageX),
                        (this.selector.style.cursor = '-webkit-grabbing'),
                        (this.sliderFrame.style.webkitTransition = 'all 0ms ' + this.config.easing),
                        (this.sliderFrame.style.transition = 'all 0ms ' + this.config.easing))
                      var t = this.config.loop ? this.currentSlide + this.perPage : this.currentSlide,
                        i = t * (this.selectorWidth / this.perPage),
                        r = this.drag.endX - this.drag.startX,
                        n = this.config.rtl ? i + r : i - r
                      this.sliderFrame.style[this.transformProperty] =
                        'translate3d(' + (this.config.rtl ? 1 : -1) * n + 'px, 0, 0)'
                    }
                  },
                },
                {
                  key: 'mouseleaveHandler',
                  value: function (e) {
                    this.pointerDown &&
                      ((this.pointerDown = !1),
                      (this.selector.style.cursor = '-webkit-grab'),
                      (this.drag.endX = e.pageX),
                      (this.drag.preventClick = !1),
                      this.enableTransition(),
                      this.updateAfterDrag(),
                      this.clearDrag())
                  },
                },
                {
                  key: 'clickHandler',
                  value: function (e) {
                    ;(this.drag.preventClick && e.preventDefault(), (this.drag.preventClick = !1))
                  },
                },
                {
                  key: 'remove',
                  value: function (e, t) {
                    if (e < 0 || e >= this.innerElements.length) throw new Error("Item to remove doesn't exist 😭")
                    var i = e < this.currentSlide,
                      r = this.currentSlide + this.perPage - 1 === e
                    ;((i || r) && this.currentSlide--,
                      this.innerElements.splice(e, 1),
                      this.buildSliderFrame(),
                      t && t.call(this))
                  },
                },
                {
                  key: 'insert',
                  value: function (e, t, i) {
                    if (t < 0 || t > this.innerElements.length + 1)
                      throw new Error('Unable to inset it at this index 😭')
                    if (-1 !== this.innerElements.indexOf(e))
                      throw new Error('The same item in a carousel? Really? Nope 😭')
                    var r = t <= this.currentSlide > 0 && this.innerElements.length
                    ;((this.currentSlide = r ? this.currentSlide + 1 : this.currentSlide),
                      this.innerElements.splice(t, 0, e),
                      this.buildSliderFrame(),
                      i && i.call(this))
                  },
                },
                {
                  key: 'prepend',
                  value: function (e, t) {
                    ;(this.insert(e, 0), t && t.call(this))
                  },
                },
                {
                  key: 'append',
                  value: function (e, t) {
                    ;(this.insert(e, this.innerElements.length + 1), t && t.call(this))
                  },
                },
                {
                  key: 'destroy',
                  value: function () {
                    var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                      t = arguments[1]
                    if ((this.detachEvents(), (this.selector.style.cursor = 'auto'), e)) {
                      for (var i = document.createDocumentFragment(), r = 0; r < this.innerElements.length; r++)
                        i.appendChild(this.innerElements[r])
                      ;((this.selector.innerHTML = ''),
                        this.selector.appendChild(i),
                        this.selector.removeAttribute('style'))
                    }
                    t && t.call(this)
                  },
                },
              ],
              [
                {
                  key: 'mergeSettings',
                  value: function (e) {
                    var t = {
                        selector: '.siema',
                        duration: 200,
                        easing: 'ease-out',
                        perPage: 1,
                        startIndex: 0,
                        draggable: !0,
                        multipleDrag: !0,
                        threshold: 20,
                        loop: !1,
                        rtl: !1,
                        onInit: function () {},
                        onChange: function () {},
                      },
                      i = e
                    for (var r in i) t[r] = i[r]
                    return t
                  },
                },
                {
                  key: 'webkitOrNot',
                  value: function () {
                    return 'string' == typeof document.documentElement.style.transform ? 'transform' : 'WebkitTransform'
                  },
                },
              ],
            ),
            e
          )
        })()
      ;((t.default = l), (e.exports = t.default))
    },
  ])
})

/* ==========================================================================
   Header & Search
   ========================================================================== */
window.addEventListener('load', function () {
  const footer = document.querySelector('#hsForm_6b5fd6df-bc72-451d-b0fd-6ca640335319')
  if (footer) {
    footer.addEventListener('submit', () => {
      ga('send', 'event', 'Form', 'Submit', 'Newsletter Signup')
      fbq('track', 'Lead')
    })
  }
})
// Search Toggle
const searchButton = document.querySelector('.search-button')
const searchFormWrapper = document.querySelector('form.desktop-search')
const searchFormInput = document.querySelector('form.desktop-search input')
const closeSearchButton = document.querySelector('.close-search-button')
const openMobileButton = document.querySelector('.nav.mobile .open-menu')
const closeMobileButton = document.querySelector('.nav.mobile .close-menu')
const mobileMenu = document.querySelector('.nav.mobile .links')
if (searchFormWrapper && searchButton) {
  searchButton.addEventListener('click', (event) => {
    event.preventDefault()
    if (searchFormWrapper.classList.contains('is-active') && searchFormInput?.value) {
      searchFormWrapper.submit()
    } else {
      searchFormWrapper.classList.toggle('is-active')
    }
  })
}
if (closeSearchButton && searchFormWrapper) {
  closeSearchButton.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    searchFormWrapper.classList.remove('is-active')
  })
}
if (searchFormWrapper) {
  document.addEventListener('click', (event) => {
    // Close search when clicking outside the form (works in all browsers; event.path is non-standard)
    if (!searchFormWrapper.contains(event.target)) {
      searchFormWrapper.classList.remove('is-active')
    }
  })
}
openMobileButton.addEventListener('click', (event) => {
  event.preventDefault()
  mobileMenu.classList.add('open')
})
closeMobileButton.addEventListener('click', (event) => {
  event.preventDefault()
  mobileMenu.classList.remove('open')
})

/* ==========================================================================
   Fixed Header: hide on scroll down, show on scroll up
   ========================================================================== */
const header = document.querySelector('.global-header')
const discoverBar = document.querySelector('.global-header-discover')
const headerSpacer = document.querySelector('.global-header-spacer')
const scrollState = {
  lastScrollY: 0,
  ticking: false,
}
const SCROLL_THRESHOLD_EXTRA = 80
function getScrollThreshold() {
  if (headerSpacer && headerSpacer.offsetHeight > 0) return headerSpacer.offsetHeight + SCROLL_THRESHOLD_EXTRA
  return 142 + SCROLL_THRESHOLD_EXTRA
}
function getScrollContainer() {
  return document.getElementById('homepage-scroll-wrapper') || null
}
function getScrollY() {
  var el = getScrollContainer()
  return el ? el.scrollTop : window.scrollY
}
function updateHeaderVisibility() {
  var scrollY = getScrollY()
  var threshold = getScrollThreshold()
  var scrollDelta = scrollY - scrollState.lastScrollY

  if (scrollY <= threshold) {
    header?.classList.remove('nav-hidden')
    discoverBar?.classList.remove('nav-hidden')
  } else if (scrollDelta > 0) {
    header?.classList.add('nav-hidden')
    discoverBar?.classList.add('nav-hidden')
  } else if (scrollDelta < 0) {
    header?.classList.remove('nav-hidden')
    discoverBar?.classList.remove('nav-hidden')
  }
  scrollState.lastScrollY = scrollY
  scrollState.ticking = false
}
function onScroll() {
  if (!scrollState.ticking) {
    scrollState.ticking = true
    requestAnimationFrame(updateHeaderVisibility)
  }
}
if (header || discoverBar) {
  scrollState.lastScrollY = getScrollY()
  var scrollContainer = getScrollContainer()
  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', onScroll, { passive: true })
  }
  window.addEventListener('scroll', onScroll, { passive: true })
}

/* ==========================================================================
   Homepage: dark header only when hero is in view (header-over-hero)
   ========================================================================== */
var heroSection = document.querySelector('.homepage-hero')
if (header && heroSection) {
  var scrollRoot = getScrollContainer() || null
  var heroObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          header.classList.add('header-over-hero')
        } else {
          header.classList.remove('header-over-hero')
        }
      })
    },
    { root: scrollRoot, rootMargin: '0px', threshold: 0 },
  )
  heroObserver.observe(heroSection)
}

/* ==========================================================================
   Smart Section Snapping — REMOVED (scroll-snap removed from homepage)
   ========================================================================== */

/* ==========================================================================
   Collections Slider
   ========================================================================== */
const collectionsSlider = document.querySelectorAll('.collections-slider')
function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el
}
;[].forEach.call(collectionsSlider, function (slider) {
  const sliderId = 'slider-' + Math.floor(Math.random() * 100000000)
  slider.id = sliderId
  const sliderElement = document.querySelector('#' + sliderId)
  const slidesPerPage = sliderElement.offsetWidth < 1200 ? Math.floor(sliderElement.offsetWidth / 240) : 5
  const prev = document.querySelector('#' + sliderId).parentNode.querySelector('.prev')
  const next = document.querySelector('#' + sliderId).parentNode.querySelector('.next')
  const mySiema = new Siema({
    selector: '#' + sliderId,
    duration: 300,
    easing: 'ease-out',
    perPage: slidesPerPage,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: false,
    rtl: false,
    onChange: () => {
      const is_last = mySiema.currentSlide === mySiema.innerElements.length - 6
      if (mySiema.currentSlide === 0) {
        prev.classList.add('hidden')
      } else {
        prev.classList.remove('hidden')
      }
      if (is_last) {
        next.classList.add('hidden')
      } else {
        next.classList.remove('hidden')
      }
    },
  })

  // Slider Pagination
  if (prev) prev.addEventListener('click', () => mySiema.prev())
  if (next) next.addEventListener('click', () => mySiema.next())
})

/* ==========================================================================
   Custom Post Slider (Blogs)
   ========================================================================== */
setTimeout(() => {
  const customPostSliderItems = document.querySelectorAll('.custom-post-slider-items')
  function setActive() {
    // Set Active Slide
    this.innerElements.forEach((slide, i) => {
      const addOrRemove = i === this.currentSlide ? 'add' : 'remove'
      this.innerElements[i].classList[addOrRemove]('active')
    })

    // Set Active Navigation
    const allNavigationItems = this.selector.parentNode.querySelectorAll('.slide-selector')
    if (allNavigationItems.length > 0) {
      const activeItem = this.selector.parentNode.querySelector(
        '.custom-post-slider-nav .slide-selector:nth-child(' + (this.currentSlide + 1) + ')',
      )
      ;[].forEach.call(allNavigationItems, function (item) {
        item.classList.remove('active')
      })
      activeItem.classList.add('active')
    }

    // Set active pagination dot
    const dotsPagination = this.selector.parentNode.querySelectorAll('.pagination-dots-wrapper .pagination-dot')
    if (dotsPagination) {
      ;[].forEach.call(dotsPagination, function (item) {
        item.classList.remove('active')
      })
      if (dotsPagination[this.currentSlide]) dotsPagination[this.currentSlide].classList.add('active')
    }
  }
  ;[].forEach.call(customPostSliderItems, function (slider) {
    const sliderDuration = 5000
    const sliderId = 'slider-' + Math.floor(Math.random() * 100000000)
    slider.id = sliderId
    const mySiema = new Siema({
      selector: '#' + sliderId,
      duration: 300,
      easing: 'ease-out',
      perPage: 1,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: true,
      rtl: false,
      onInit: setActive,
      onChange: setActive,
    })

    // Slider Pagination
    const prev = document.querySelector('#' + sliderId).parentNode.querySelector('.prev')
    const next = document.querySelector('#' + sliderId).parentNode.querySelector('.next')
    if (prev) prev.addEventListener('click', () => mySiema.prev())
    if (next) next.addEventListener('click', () => mySiema.next())

    // Slider auto paginate
    setInterval(() => {
      mySiema.next()
    }, sliderDuration)

    // Slider Thumbnail Navigation
    const sliderNavigation = document
      .querySelector('#' + sliderId)
      .parentNode.querySelector('.custom-post-slider-nav-wrapper')
    if (sliderNavigation) {
      const sliderNavigationItems = sliderNavigation.querySelectorAll('.slide-selector')
      ;[].forEach.call(sliderNavigationItems, function (item, index) {
        item.addEventListener('click', () => {
          mySiema.goTo(index)
        })
      })
    }

    // Slider progressbar
    const animate = (style, unit, from, to, time) => {
      if (!slider.querySelector('[data-progress-bar]')) return
      const start = new Date().getTime()
      const timer = setInterval(() => {
        const step = Math.min(1, (new Date().getTime() - start) / time)
        slider.querySelector('[data-progress-bar]').style[style] = from + step * (to - from) + unit
        if (step == 1) clearInterval(timer)
      }, 25)
      slider.querySelector('[data-progress-bar]').style[style] = from + unit
    }
  })
}, 2000)

/* ==========================================================================
   Hero Slider (mobile only)
   ========================================================================== */
const heroSlider = document.querySelectorAll('.split-hero-banner')
function getWidth() {
  return Math.max(document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth)
}
if (getWidth() < 768) {
  ;[].forEach.call(heroSlider, function (slider) {
    const sliderId = 'hero-slider-' + Math.floor(Math.random() * 100000000)
    slider.id = sliderId
    const sliderElement = document.querySelector('#' + sliderId)
    const slidesPerPage = 1
    let mySiema = new Siema({
      selector: '#' + sliderId,
      duration: 300,
      easing: 'ease-out',
      perPage: slidesPerPage,
      startIndex: 0,
      draggable: true,
      multipleDrag: true,
      threshold: 20,
      loop: false,
      rtl: false,
      onChange: () => {},
    })
  })
}

/* ==========================================================================
   Programs Slider
   ========================================================================== */
const programsSlider = document.querySelectorAll('.programs-slider')
;[].forEach.call(programsSlider, function (slider) {
  const sliderId = 'slider-' + Math.floor(Math.random() * 100000000)
  slider.id = sliderId
  const sliderElement = document.querySelector('#' + sliderId)
  const slidesPerPage = Math.floor(sliderElement.offsetWidth / 300)
  const prev = sliderElement.parentNode.parentNode.querySelector('.prev')
  const next = sliderElement.parentNode.parentNode.querySelector('.next')
  let mySiema = new Siema({
    selector: '#' + sliderId,
    duration: 800,
    easing: 'ease-out',
    perPage: slidesPerPage == 0 ? 1 : slidesPerPage,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: false,
    rtl: false,
    onChange: () => {
      const is_last = mySiema.currentSlide === mySiema.innerElements.length - slidesPerPage
      if (mySiema.currentSlide === 0) {
        prev.classList.add('hidden')
      } else {
        prev.classList.remove('hidden')
      }
      if (is_last) {
        next.classList.add('hidden')
      } else {
        next.classList.remove('hidden')
      }
    },
  })
  if (prev) prev.addEventListener('click', () => mySiema.prev())
  if (next) next.addEventListener('click', () => mySiema.next())
})

/* ==========================================================================
   Collection List Auto-Slider
   ========================================================================== */
const collectionSliderItems = document.querySelectorAll('.collection-list')
;[].forEach.call(collectionSliderItems, function (slider) {
  const sliderId = 'collection-slider-' + Math.floor(Math.random() * 10)
  slider.id = sliderId
  const mySiema = new Siema({
    selector: '#' + sliderId,
    duration: 800,
    easing: 'ease-out',
    perPage: 4,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: true,
    rtl: false,
  })
  setInterval(() => {
    mySiema.next()
  }, 3000)
})

/* ==========================================================================
   Donation Thank-You Gallery
   ========================================================================== */
const donateGallery = document.querySelectorAll('.donate-ty-gallery-wrapper')
;[].forEach.call(donateGallery, function (slider) {
  const sliderId = 'slider-' + Math.floor(Math.random() * 10)
  slider.id = sliderId
  const mySiema = new Siema({
    selector: '#' + sliderId,
    duration: 400,
    easing: 'ease-out',
    perPage: 1,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: true,
    rtl: false,
  })
  setInterval(() => {
    mySiema.next()
  }, 3000)
})

/* ==========================================================================
   Donation Popup
   ========================================================================== */
const donatePopup = document.querySelector('.give-now-popup-wrapper')
const donatePopupClose = document.querySelector('.give-now-popup-wrapper .js-close-popup')
if (donatePopup) {
  setTimeout(() => {
    donatePopup.classList.add('is-active')
  }, 5000)
  donatePopupClose.addEventListener('click', () => {
    donatePopup.classList.remove('is-active')
  })
}

/* ==========================================================================
   Product Thumbnail Gallery
   ========================================================================== */
const variationGallery = document.querySelectorAll('.variation-gallery')
;[].forEach.call(variationGallery, function (slider) {
  const sliderId = 'slider-' + Math.floor(Math.random() * 10)
  slider.id = sliderId
  const mySiema = new Siema({
    selector: '#' + sliderId,
    duration: 300,
    easing: 'ease-out',
    perPage: 3,
    startIndex: 0,
    draggable: true,
    multipleDrag: true,
    threshold: 20,
    loop: false,
    rtl: false,
  })

  // Slider Thumbnail Navigation
  const slides = mySiema.selector.querySelectorAll('[data-product-single-thumbnail]')
  if (slides) {
    ;[].forEach.call(slides, function (item, index) {
      item.addEventListener('click', () => {
        const itemImage = item.getAttribute('data-large-image')
        const mainImage = document.querySelector('.responsive-image__image')
        if (itemImage) mainImage.src = itemImage
      })
    })
  }
})

/* ==========================================================================
   Trainer Filter
   ========================================================================== */
const trainerTypeRadios = document.getElementsByName('trainer-types')
if (trainerTypeRadios.length > 0) {
  ;[].forEach.call(trainerTypeRadios, function (type) {
    if (type.checked) filterTrainers(type)
    type.addEventListener('click', (event) => {
      filterTrainers(type)
    })
  })
}
function filterTrainers(type) {
  const allTrainers = document.querySelectorAll('[data-trainer-type]')
  const activeType = type.value
  ;[].forEach.call(allTrainers, function (trainer) {
    if (trainer.dataset.trainerType.includes(activeType)) {
      trainer.classList.remove('is-hiding')
      trainer.classList.remove('hidden')
    } else {
      trainer.classList.add('is-hiding')
      setTimeout(() => {
        trainer.classList.add('hidden')
      }, 600)
    }
  })
}

/* ==========================================================================
   Image Fallback Check
   ========================================================================== */
const imageBackups = document.querySelectorAll('[data-image-backup]')
const imageExist = (url) =>
  fetch(url, {
    method: 'HEAD',
  })
    .then((res) => res.ok)
    .catch((err) => console.log('Error:', err))
;[].forEach.call(imageBackups, async function (image) {
  if (!(await imageExist(image.href.baseVal))) image.remove()
})

/* ==========================================================================
   Navigation (desktop & mobile dropdowns + underlay)
   ========================================================================== */
document.addEventListener('DOMContentLoaded', () => {
  const underlay = document.querySelector('.underlay')

  const closeMenu = (ignoreToggle = false) => {
    const openNavLinks = document.querySelector('.nav.desktop .nav-menu.open')
    if (openNavLinks) {
      openNavLinks.classList.remove('open')
      document
        .querySelectorAll('.nav.desktop .js_parent-nav-link.active')
        .forEach((el) => el.classList.remove('active'))
      closeMenu(true)
    }
    if (!ignoreToggle) {
      toggleUnderlay(false)
    }
  }

  const toggleUnderlay = (shouldOpen) => {
    if (shouldOpen) {
      underlay.classList.add('open')
    } else {
      underlay.classList.remove('open')
      closeMenu(true)
    }
  }

  const handleMenuOpen = (e, link) => {
    e.preventDefault()
    const menuHandle = link.dataset.menu
    if (!menuHandle) return
    const submenu = link.parentElement.querySelector(`.nav-menu[data-menu="${menuHandle}"]`)
    if (!submenu) return
    if (submenu.classList.contains('open')) {
      submenu.classList.remove('open')
      link.classList.remove('active')
      toggleUnderlay(false)
    } else {
      closeMenu()
      submenu.classList.add('open')
      document
        .querySelectorAll('.nav.desktop .js_parent-nav-link.active')
        .forEach((el) => el.classList.remove('active'))
      link.classList.add('active')
      toggleUnderlay(true)
    }
  }

  const handleMobileMenuOpen = (e, link) => {
    e.preventDefault()
    const submenu = link.nextElementSibling
    if (submenu.classList.contains('open')) {
      submenu.classList.remove('open')
      toggleUnderlay(false)
    } else {
      closeMenu()
      submenu.classList.add('open')
      toggleUnderlay(true)
    }
  }

  const desktopNavLinks = document.querySelectorAll('.nav.desktop .js_parent-nav-link')
  desktopNavLinks.forEach((navItem) => {
    navItem.addEventListener('click', (e) => handleMenuOpen(e, navItem))
  })

  const mobileNavLinks = document.querySelectorAll('.nav.mobile .js_parent-nav-link')
  mobileNavLinks.forEach((navItem) => {
    navItem.addEventListener('click', (e) => handleMobileMenuOpen(e, navItem))
  })

  underlay.addEventListener('click', () => toggleUnderlay(false))
})

/**
 * Section Heading — entrance animation
 *
 * For each [data-section-heading-animate] wrapper:
 *   - If data-animate-scope is set, watches that ancestor for .is-active
 *   - Otherwise uses IntersectionObserver to trigger .is-visible on viewport entry
 */
;(function () {
  function initSectionHeadingAnimations() {
    document.querySelectorAll('[data-section-heading-animate]').forEach(function (el) {
      if (el._shInit) return
      el._shInit = true

      var scopeSelector = el.getAttribute('data-animate-scope')
      if (scopeSelector) {
        var scope = el.closest(scopeSelector)
        if (scope) {
          if (scope.classList.contains('is-active')) {
            el.classList.add('is-visible')
            return
          }
          var mo = new MutationObserver(function () {
            if (scope.classList.contains('is-active')) {
              el.classList.add('is-visible')
              mo.disconnect()
            }
          })
          mo.observe(scope, { attributes: true, attributeFilter: ['class'] })
          return
        }
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('is-visible')
              observer.unobserve(el)
            }
          })
        },
        { threshold: 0.15 },
      )
      observer.observe(el)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSectionHeadingAnimations)
  } else {
    initSectionHeadingAnimations()
  }
})()
